import { render } from "./draggable.vue?vue&type=template&id=61d5ce09&scoped=true&lang=pug"
import script from "./draggable.vue?vue&type=script&lang=js"
export * from "./draggable.vue?vue&type=script&lang=js"

import "./draggable.vue?vue&type=style&index=0&id=61d5ce09&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d5ce09"]])

export default __exports__